import { render, staticRenderFns } from "./CurrencyJournalDetail.vue?vue&type=template&id=6d3cc40d&scoped=true&lang=html&"
import script from "./CurrencyJournalDetail.vue?vue&type=script&lang=js&"
export * from "./CurrencyJournalDetail.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyJournalDetail.vue?vue&type=style&index=0&id=6d3cc40d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3cc40d",
  null
  
)

export default component.exports